import styled from 'styled-components';

/* ── Wrapper principal ── */
export const Body = styled.div`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 2rem 1.5rem;
  animation: fadeInUp 0.35s ease both;

  @media (max-width: 600px) {
    padding: 1.5rem 1rem;
  }
`;

/* ── Card principal com info do produto ── */
export const ProductDetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1.5rem;
  background-color: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.sizes.borderRadiusMd};
  box-shadow: ${(props) => props.theme.shadows.md};
`;

/* ── Layout interno: imagem + info ── */
export const ProductLayout = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;

  @media (max-width: 560px) {
    flex-direction: column;
  }
`;

export const ProductInfoContainer = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ProductName = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.title};
  line-height: 1.3;
  letter-spacing: -0.2px;
`;

export const ProductDescription = styled.p`
  font-size: 14px;
  line-height: 1.65;
  color: ${(props) => props.theme.colors.text};
`;

/* ── Divider ── */
export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${(props) => props.theme.colors.border};
  margin: 0.5rem 0;
`;

/* ── Grid de campos dinâmicos (resource.fields) ── */
export const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 0.75rem;
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.75rem;
  background-color: ${(props) => props.theme.colors.surface};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.sizes.borderRadius};
`;

export const StatLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primary};
  text-transform: uppercase;
  letter-spacing: 0.6px;
`;

export const StatValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.title};
`;

/* ── Card de perguntas ── */
export const QuestionsCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1.5rem;
  background-color: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.sizes.borderRadiusMd};
  box-shadow: ${(props) => props.theme.shadows.sm};
`;

export const QuestionsTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.title};
  padding-bottom: 0.75rem;
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
`;

export const QuestionScroll = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 0.75rem;
  border-top: 1px solid ${(props) => props.theme.colors.border};

  > div {
    min-width: 140px;
  }
`;

/* ── Mensagem de sucesso pós-submit ── */
export const SubmittedMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 2rem 1rem;
  text-align: center;

  h4 {
    font-size: 16px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.success};
  }

  p {
    font-size: 14px;
    color: ${(props) => props.theme.colors.textMuted};
  }
`;

/* ── Alerta de Extraviado ── */
export const ExtraviadoAlert = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  background-color: ${(props) => props.theme.colors.errorBg};
  border: 1px solid ${(props) => props.theme.colors.error};
  border-radius: ${(props) => props.theme.sizes.borderRadiusMd};
  box-shadow: ${(props) => props.theme.shadows.sm};
  
  p {
    font-size: 15px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.error};
    line-height: 1.4;
  }

  svg {
    flex-shrink: 0;
    color: ${(props) => props.theme.colors.error};
  }
`;

/* ── Mensagem "sem perguntas disponíveis" ── */
export const NoInteractionMessage = styled.div<{ isWarning?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background-color: ${(props) => props.isWarning ? props.theme.colors.warningBg : props.theme.colors.surface};
  border: 1px solid ${(props) => props.isWarning ? props.theme.colors.warning : props.theme.colors.border};
  border-radius: ${(props) => props.theme.sizes.borderRadius};

  p {
    font-size: 14px;
    font-weight: 500;
    color: ${(props) => props.isWarning ? props.theme.colors.warning : props.theme.colors.text};
  }
  
  svg {
    color: ${(props) => props.isWarning ? props.theme.colors.warning : props.theme.colors.textMuted};
  }
`;

export const TimeText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.textMuted};
`;

/* ── Card de Itens Agregados ── */
export const AggregatedItemsCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  background-color: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.sizes.borderRadiusMd};
  box-shadow: ${(props) => props.theme.shadows.sm};
`;

export const AggregatedTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.title};
  padding-bottom: 0.75rem;
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  svg {
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const AggregatedList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  list-style: none;
`;

export const AggregatedItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background-color: ${(props) => props.theme.colors.surface};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  transition: border-color ${(props) => props.theme.transitions.fast};

  &:hover {
    border-color: ${(props) => props.theme.colors.primaryLight};
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    strong {
      font-size: 14px;
      font-weight: 600;
      color: ${(props) => props.theme.colors.title};
    }

    span {
      font-size: 12px;
      color: ${(props) => props.theme.colors.textMuted};
      font-family: monospace;
    }
  }

  .date {
    font-size: 12px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.textMuted};
    background-color: ${(props) => props.theme.colors.background};
    padding: 0.25rem 0.5rem;
    border-radius: ${(props) => props.theme.sizes.borderRadius};
    border: 1px solid ${(props) => props.theme.colors.border};
  }
`;
